// [ai] Which hrefs the shell navigates itself. Absolute app paths (and full URLs on this origin) that are pages; never the
// player's link grammar (rec:/note: — PlayerLayer's), never a file the server streams (/raw, /api, /lib, /sdk, /assets,
// /imports/<id>/file/…), never another origin, a hash-only jump, or mailto.
const FILES = /^\/(api|raw|lib|sdk|assets|data)\/|^\/imports\/[^/]+\/file\//;
export function isAppHref(href: string | null): string | null {
  if (!href || /^(rec|note|mailto|tel|javascript):/i.test(href) || href.startsWith("#")) return null;
  let u: URL; try { u = new URL(href, location.href); } catch { return null; }
  if (u.origin !== location.origin || FILES.test(u.pathname)) return null;
  return u.pathname + u.search + u.hash;
}
